import React, { Component } from 'react';
import Select from 'react-select';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { setVersaoSelecionada } from '../actions';
import axios from 'axios';

export class VersionSelector extends Component {
    constructor(props) {
        super(props);
        this._searchVersion();
    }

    state = {
        versions: [],
        inputValue: '',
    };

    _searchVersion = async () => {
        let versions = await axios.get('/dadomestre/versao/versaoUsuario');
        this.state.versions = versions.data.map((x) => ({
            value: x,
            label: x.nome + (x.login !== '' ? '_' + x.login : '') + '(' + x.sequencial + ')',
        }));
    };

    _onChange = (inputValue, { action }) => {
        this.props.setVersaoSelecionada(inputValue.value);
        if (this.props.onChange) this.props.onChange(inputValue.value);
    };

    _getDefaultValue = () => {
        return this.state.versions.find((x) => {
            if (this.props.versaoSelecionada) {
                if (this.props.versaoSelecionada.login === '') return x.value.login === this.props.versaoSelecionada.login;
                else return x.value._id === this.props.versaoSelecionada._id;
            } else return true;
        });
    };

    render() {
        return (
            <Select
                id='versionSelector'
                //defaultValue={this._getDefaultValue()}
                onChange={this._onChange}
                isClearable
                isSearchable
                inputValue={this.state.inputValue}
                value={this._getDefaultValue()}
                name='versionSelector'
                options={this.state.versions}
                placeholder='Versões'
            />
        );
    }
}

const mapStateToProps = (store) => ({
    versaoSelecionada: store.versaoState.versao,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setVersaoSelecionada,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(VersionSelector);
